// extracted by mini-css-extract-plugin
module.exports = {"container":"Lottie-module--container--aq1wi"};